import { render, staticRenderFns } from "./CardExercise.vue?vue&type=template&id=91ab9756&"
import script from "./CardExercise.vue?vue&type=script&lang=js&"
export * from "./CardExercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports